// src/components/Sidebar.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { buildMenuItems, findMenu } from '../config/menuConfig';
import { isSuperAdmin, SUPER_ONLY_PATHS } from '../utils/auth';
import './Sidebar.css';

const Sidebar = ({ visible, onClose }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = findMenu(location.pathname);
  const [openKeys, setOpenKeys] = useState(active ? [active.sectionKey] : []);
  // 个性配置（doc01 3.6）：导航栏 logo 随「登录页 / 导航栏 logo」保存实时更新
  const [logo, setLogo] = useState(() => localStorage.getItem('themeLoginLogo') || '/logo.png');
  const [superAdmin, setSuperAdmin] = useState(() => isSuperAdmin());

  useEffect(() => {
    const sync = () => setLogo(localStorage.getItem('themeLoginLogo') || '/logo.png');
    const syncUser = () => setSuperAdmin(isSuperAdmin());
    window.addEventListener('storage', sync);
    window.addEventListener('storage', syncUser);
    window.addEventListener('ems-theme-changed', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('storage', syncUser);
      window.removeEventListener('ems-theme-changed', sync);
    };
  }, []);

  // 路径变化时自动展开所在分组
  useEffect(() => {
    const found = findMenu(location.pathname);
    if (found) {
      setOpenKeys((prev) => (prev.includes(found.sectionKey) ? prev : [...prev, found.sectionKey]));
    }
  }, [location.pathname]);

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <div className={`sidebar-container ${visible ? 'sidebar-visible' : ''}`}>
      <div className="sidebar-logo-area">
        <img
          src={logo}
          alt="能源管家"
          className="sidebar-logo-img"
          style={{
            background: 'rgba(243, 246, 248, 0.5)',
            border: '1px solid rgba(98, 123, 185, 0.3)',
          }}
        />
        {visible && (
          <button className="sidebar-close-btn" onClick={onClose}>
            <CloseOutlined />
          </button>
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        items={buildMenuItems(i18n.language, superAdmin ? [] : SUPER_ONLY_PATHS)}
        onClick={handleMenuClick}
      />
    </div>
  );
};

export default Sidebar;